import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import Link from 'next/link'
import type { ComponentProps } from 'react'
import type { ButtonVariants } from './Button'
import { buttonVariants } from './Button'
import { FontAwesomeIcon } from './FontAwesomeIcon'

export type ButtonLinkProps = Omit<ComponentProps<typeof Link>, 'children'> &
	Omit<ButtonVariants, 'hasIcon'> & {
		href: string
		label: string
		icon?: [IconPrefix, IconName]
	}

export const ButtonLink = ({
	intent,
	theme,
	label,
	title,
	icon,
	className,
	href,
	target,
	...props
}: ButtonLinkProps) => {
	const hasIcon = icon !== undefined
	return (
		<Link
			{...props}
			href={href}
			target={target}
			className={buttonVariants({ intent, theme, hasIcon, className })}
			title={title || label}
		>
			<span className="relative z-10">{label}</span>
			{icon && <FontAwesomeIcon icon={icon} size="md" className="relative z-10" />}
		</Link>
	)
}
